// export const filterRoutesByBackendPermissions = (
//     routesConfig,
//     rolePermissions,
//     userRole,
//     userId
// ) => {
//     if (!rolePermissions || !userRole) return [];


//     // ✅ Handle both object and array formats
//     const currentRole = Array.isArray(rolePermissions)
//         ? rolePermissions.find(
//             (role) => role.roleName?.toLowerCase() === userRole?.toLowerCase()
//         )
//         : rolePermissions[userRole?.toLowerCase()] || rolePermissions[userRole];

//     if (!currentRole) {
//         console.warn("⚠️ No matching role found for:", userRole);
//         return [];
//     }

//     const allowedModules = (currentRole.modules || []).map((m) => m.toLowerCase());
//     const excludedModules = (currentRole.excludedModules || []).map((m) =>
//         m.toLowerCase()
//     );
//     const assignedEmployees = (currentRole.employees || []).map((e) => e.toString());

//     return routesConfig.filter((route) => {
//         const comp = route.component?.toLowerCase() || "";
//         const path = route.path?.toLowerCase() || "";

//         // 🚫 1️⃣ Block excluded modules ALWAYS (even if not private)
//         const isExcluded = excludedModules.some(
//             (ex) => comp.includes(ex) || path.includes(ex)
//         );
//         if (isExcluded) {
//             console.log(`⛔ Blocked excluded module: ${comp}`);
//             return false;
//         }

//         // 🔓 2️⃣ Allow public routes (if not excluded)
//         if (!route.private) return true;

//         // 🌍 3️⃣ Wildcard access gives full access except excluded
//         if (allowedModules.includes("*")) return true;

//         // ✅ 4️⃣ Check allowed modules
//         const isAllowedModule = allowedModules.some(
//             (m) => comp.includes(m) || path.includes(m)
//         );

//         // 👤 5️⃣ Check if user has specific access
//         const hasEmployeeAccess = assignedEmployees.includes(userId?.toString());

//         // 🧠 6️⃣ Final decision for private routes
//         const finalAccess = isAllowedModule || hasEmployeeAccess;

//         if (!finalAccess) {
//             console.log(`🚷 Access denied for ${comp} (User: ${userId}, Role: ${userRole})`);
//         }

//         return finalAccess;
//     });
// };






// ✅ NEW SIMPLE FUNCTION:
export const filterRoutesByBackendPermissions = (
    routesConfig,
    userPermissions, // Direct from currentAdmin.permissions
    roleInfo         // Direct from currentAdmin.roleInfo
) => {
    if (!userPermissions) return [];

    const normRole = (r) => (r || '').toLowerCase().replace(/[\s_-]+/g, '_');
    const userRole = normRole(roleInfo?.name || '');

    // 👑 Privileged bypass: Show all routes regardless of module permissions for super_admin, admin, and hr_admin
    if (['super_admin', 'admin', 'hr_admin'].includes(userRole) || userRole.includes('admin')) {
        return routesConfig;
    }

    // Get all modules user has access to (any actions = has access)
    const allowedModules = Object.keys(userPermissions)
        .filter(moduleName => userPermissions[moduleName]?.length > 0)
        .map(m => m.toLowerCase());

    return routesConfig.filter((route) => {
        const comp = (route.component || '').toLowerCase();
        const path = (route.path || '').toLowerCase();
        const routeRoles = (route.roles || []).map(r => normRole(r));

        // 🔓 1. Allow public routes
        if (!route.private) return true;

        // ✅ 2. Allow if role is 'all' or specifically allowed for this route (Ensures fundamental access)
        if (routeRoles.includes('all') || (userRole && routeRoles.includes(userRole))) {
            return true;
        }

        // 🔑 3. Check if route matches any allowed module from permissions (Fine-grained access)
        const isPermissionAllowed = allowedModules.some(
            (moduleName) => {
                const isProjectMatch = moduleName === 'projectmanagement' && (comp.includes('project') || path.includes('project'));
                return isProjectMatch ||
                    comp.includes(moduleName) ||
                    path.includes(moduleName) ||
                    path === moduleName ||
                    comp === moduleName;
            }
        );

        return isPermissionAllowed;
    });
};

